export default class DynamicGeofenceError extends Error {
  constructor(...args: any[]) {
    super(...args);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, DynamicGeofenceError);
    }
  }
}
